import { SENDA } from '@somnhold/content';
import { cellId } from '../grid.ts';
import { hexToWorld, type Hex } from '../hex.ts';
import type { CliffRules } from '../galo-types.ts';
import type { CliffLayout } from './cliff-layout.ts';

/**
 * The ranger's chapter 2 rules from their layouts (docs/sendas/explorador.md, «El Acantilado del Flanco»): the fight's
 * builder (campaign/sendas.ts) and the drawing build them the same way. SENDA.galo. `radius`: the board's.
 */

const at = (h: Hex): { x: number; y: number } => hexToWorld(h.q, h.r);

export const cliffRules = (L: CliffLayout, radius: number, act: 'edge' | 'wall' | 'night', motherHp: number): CliffRules => {
  const G = SENDA.galo;
  const W = act === 'night' ? G.night : G.wall;
  return {
    act,
    ledges: L.ledges.map((l) => {
      const cells = l.cells.map((c) => cellId(radius, c.q, c.r)).sort((a, b) => a - b);
      // Its middle: the cell nearest the span's middle on its front row.
      const front = l.cells.filter((c) => c.r === Math.trunc(l.cells.reduce((m, x) => (x.r > m ? x.r : m), -99)));
      const mx = Math.trunc((l.x0 + l.x1) / 2);
      let mid = at(front[0] ?? (l.cells[0] as Hex));
      for (const c of front) if (Math.abs(at(c).x - mx) < Math.abs(mid.x - mx)) mid = at(c);
      return { cells, level: l.level, mid, goal: l.goal };
    }),
    cracks: L.cracks.map((c) => ({ ...at(c.h), kind: c.kind, land: c.land, top: c.top })),
    nests: L.nests.map(at),
    holes: L.holes.map(at),
    stones: L.stones.map((s) => ({ ...at(s.h), ledge: s.ledge })),
    crewFrom: { x: L.crew * 10500, y: 0 },
    rope: W.rope,
    aim: W.aim,
    speed: W.speed,
    hold: W.hold,
    fallBp: W.fallBp,
    nestR: G.wall.nest,
    nestCrows: G.wall.crows,
    crew: { ...(act === 'night' ? G.night.crew : G.wall.crew) },
    ...(act === 'edge'
      ? { edge: { time: G.edge.time, hammer: G.edge.hammer, anchor: at(L.anchor), crows: { ...G.edge.crows }, shriek: { ...G.edge.shriek } } }
      : {}),
    ...(act === 'night'
      ? { night: { stone: G.night.stone, mem: G.night.mem, knockBp: G.night.knockBp, shriek: { ...G.night.shriek }, mother: { hp: motherHp, at: G.night.mother.at, first: G.night.mother.first, every: G.night.mother.every, call: G.night.mother.call, warn: G.night.mother.warn, r: G.night.mother.r, stun: G.night.mother.stun, heroBp: G.night.mother.heroBp, keep: G.night.mother.keep } } }
      : {}),
    shrieker: { speed: G.shrieker.speed, bite: { ...G.shrieker.bite, ...(act === 'edge' ? { heroBp: G.edge.biteBp } : {}) } },
  };
};
